export const paymentMethodTypes = {
  BANK: 'BANK',
  CARD: 'CARD',
  PAY_INTERNAL: 'PAY_INTERNAL',
  WALLET: 'WALLET',
} as const;

export const paymentMethodCodes = {
  AFFIRM: 'Affirm',
  ALIPAY_CN: 'AlipayCN',
  ALIPAY_HK: 'AlipayHK',
  APPLE_PAY: 'ApplePay',
  APP_CARD: 'AppCard',
  BANCONTACT: 'Bancontact',
  CARD: 'CARD',
  DUMMY_BANK: 'IBE',
  GOOGLE_PAY: 'GooglePay',
  IDEAL: 'IDeal',
  KLARNA_ONE: 'OneKlarna',
  KLARNA_PAY_LATER: 'KlarnaPayLater',
  KLARNA_PAY_NOW: 'KlarnaPayNow',
  KLARNA_SLICE_IT: 'KlarnaSliceIt',
  KLARNA_SOFORT: 'KlarnaSofortuberweisung',
  ONLINE_BANKING_PL: 'OnlineBankingPl',
  PAYPAL: 'PayPal',
  PIX: 'Pix',
  SOFORT: 'Sofort',
  TRUSTLY: 'Trustly',
  UPI: 'Upi',
} as const;
